import { render, staticRenderFns } from "./RecentOutingsBox.vue?vue&type=template&id=3d380f6e&scoped=true"
import script from "./RecentOutingsBox.vue?vue&type=script&lang=js"
export * from "./RecentOutingsBox.vue?vue&type=script&lang=js"
import style0 from "./RecentOutingsBox.vue?vue&type=style&index=0&id=3d380f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d380f6e",
  null
  
)

export default component.exports